import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchAgentDailyTarget,
  fetchAgentTargetStats,
  fetchAgentWeeklyTarget,
  fetchBCALogs,
  fetchBCAStats,
  fetchBTLLeads,
  fetchBTLVendors,
  fetchCashReports,
  fetchCheckedInMembers,
  fetchDeletedStaff,
  fetchStaffOffboarding,
  fetchDiscountPaymentCreation,
  fetchFDDFPaymentCreation,
  fetchFDDPaymentLinkAccess,
  fetchFitnessProfileLogs,
  fetchFitnessProfileStats,
  fetchFreshLeads,
  fetchFreshLeadsV2,
  fetchGymKeywords,
  fetchGymKeywordStats,
  fetchLeadCycle,
  fetchLeadTimeline,
  fetchLMSFollowups,
  fetchPtProspects,
  fetchPtProspectsStats,
  fetchReceptionists,
  fetchReferrals,
  fetchReferralStat,
  fetchStaffOnboardingRequests,
  fetchStaffProfiles,
  fetchTMEApprovalManager,
  fetchWaitGymwise,
  fetchWalkinLeads,
  fetchClosureExpectedStats,
  fetchRedFlags,
  fetchVisitSuccessMetrics,
  fetchRecentGymActivity,
  fetchPipelineStats,
  fetchClosurePipelineCriticalTracking,
  fetchClosurePipelineCriticalTrackingOverview,
  fetchClosureExpectedDeepTracker,
  fetchDeepTrackerTimelineView,
  fetchClosurePatternAnalysis,
  fetchDailyLeadMovementStats,
  fetchAgentManagement,
  fetchAcademyLeads,
  fetchStaffAttendanceStats,
  fetchMemberCheckinMetrics,
  fetchGymwiseCheckinMetrics,
  fetchGymCardStats,
  fetchGymDistributionStats,
  fetchGymSegmentMembers,
  fetchRegularizationRequest,
  fetchTMEGymwiseAnalysis,
  fetchTMECheckinAnalysis,
  fetchTMECheckinBreakdown,
  fetchTMECheckinTimeline,
  fetchExpiredMembers,
  fetchGymRetentionStats,
  fetchMemberWeight,
  fetchBMIChart,
  fetchHealthTracking,
  fetchWTF360Consultations,
  fetchDiscountApprovalAccess,
  fetchCallLogs,
  fetchTrainerStats,
  fetchTrainerStatsDetails,
  fetchWTF360Inquiry,
  fetchPreSaleGymLeads,
} from "./prospectApis";

export const fetchPtProspectsStatsData = createAsyncThunk(
  "api/fetchPtProspectsStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchPtProspectsStats(filters, token);
    return response;
  }
);

export const fetchPtProspectsData = createAsyncThunk(
  "api/fetchPtProspectsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchPtProspects(filters, token);
    return response;
  }
);

export const fetchFDDFPaymentCreationData = createAsyncThunk(
  "api/fetchFDDFPaymentCreationData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchFDDFPaymentCreation(filters, token);
    return response;
  }
);

export const fetchDiscountPaymentCreationData = createAsyncThunk(
  "api/fetchDiscountPaymentCreationData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchDiscountPaymentCreation(filters, token);
    return response;
  }
);

export const fetchFDDPaymentLinkAccessData = createAsyncThunk(
  "api/fetchFDDPaymentLinkAccessData",
  async (payload, { getState }) => {
    const { user_id, filters, token } = payload;
    const response = await fetchFDDPaymentLinkAccess(user_id, filters, token);
    return response;
  }
);

export const fetchReferralStatData = createAsyncThunk(
  "api/fetchReferralStatData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchReferralStat(filters, token);
    return response;
  }
);

export const fetchReferralsData = createAsyncThunk(
  "api/fetchReferralsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchReferrals(filters, token);
    return response;
  }
);

export const fetchTMEApprovalManagerData = createAsyncThunk(
  "api/fetchTMEApprovalManagerData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTMEApprovalManager(filters, token);
    return response;
  }
);

export const fetchAgentTargetStatsData = createAsyncThunk(
  "prospects/fetchAgentTargetStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAgentTargetStats(filters, token);
    return response;
  }
);

export const fetchAgentDailyTargetata = createAsyncThunk(
  "prospects/fetchAgentDailyTargetata",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAgentDailyTarget(filters, token);
    return response;
  }
);

export const fetchAgentWeeklyTargetData = createAsyncThunk(
  "prospects/fetchAgentWeeklyTargetData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAgentWeeklyTarget(filters, token);
    return response;
  }
);

export const fetchCheckedInMembersData = createAsyncThunk(
  "api/fetchCheckedInMembersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchCheckedInMembers(filters, token);
    return response;
  }
);

export const fetchBTLVendorsData = createAsyncThunk(
  "api/fetchBTLVendorsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchBTLVendors(filters, token);
    return response;
  }
);

export const fetchBTLLeadsData = createAsyncThunk(
  "api/fetchBTLLeadsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchBTLLeads(filters, token);
    return response;
  }
);

export const fetchStaffOnboardingRequestsData = createAsyncThunk(
  "prospects/fetchStaffOnboardingRequestsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchStaffOnboardingRequests(filters, token);
    return response;
  }
);

export const fetchDeletedStaffData = createAsyncThunk(
  "prospects/fetchDeletedStaffData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchDeletedStaff(filters, token);
    return response;
  }
);

export const fetchStaffOffboardingData = createAsyncThunk(
  "prospects/fetchStaffOffboardingData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchStaffOffboarding(filters, token);
    return response;
  }
);

export const fetchReceptionistsData = createAsyncThunk(
  "prospects/fetchReceptionistsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchReceptionists(filters, token);
    return response;
  }
);

export const fetchGymKeywordStatsData = createAsyncThunk(
  "prospects/fetchGymKeywordStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymKeywordStats(filters, token);
    return response;
  }
);

export const fetchGymKeywordsData = createAsyncThunk(
  "prospects/fetchGymKeywordsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymKeywords(filters, token);
    return response;
  }
);

export const fetchCashReportsData = createAsyncThunk(
  "prospects/fetchCashReportsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchCashReports(filters, token);
    return response;
  }
);

export const fetchWalkinLeadsData = createAsyncThunk(
  "prospects/fetchWalkinLeadsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchWalkinLeads(filters, token);
    return response;
  }
);

export const fetchFitnessProfileLogsData = createAsyncThunk(
  "prospects/fetchFitnessProfileLogsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchFitnessProfileLogs(filters, token);
    return response;
  }
);

export const fetchFitnessProfileStatsData = createAsyncThunk(
  "prospects/fetchFitnessProfileStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchFitnessProfileStats(filters, token);
    return response;
  }
);

export const fetchBCALogsData = createAsyncThunk(
  "prospects/fetchBCALogsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchBCALogs(filters, token);
    return response;
  }
);

export const fetchBCAStatsData = createAsyncThunk(
  "prospects/fetchBCAStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchBCAStats(filters, token);
    return response;
  }
);

export const fetchLeadTimelineData = createAsyncThunk(
  "prospects/fetchLeadTimelineData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchLeadTimeline(filters, token);
    return response;
  }
);

export const fetchLeadCycleData = createAsyncThunk(
  "prospects/fetchLeadCycleData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchLeadCycle(filters, token);
    return response;
  }
);

export const fetchLMSFollowupsData = createAsyncThunk(
  "prospects/fetchLMSFollowupsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchLMSFollowups(filters, token);
    return response;
  }
);

export const fetchWaitGymwiseData = createAsyncThunk(
  "prospects/fetchWaitGymwiseData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchWaitGymwise(filters, token);
    return response;
  }
);

export const fetchFreshLeadsData = createAsyncThunk(
  "prospects/fetchFreshLeadsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchFreshLeads(filters, token);
    return response;
  }
);

export const fetchStaffProfilesData = createAsyncThunk(
  "prospects/fetchStaffProfilesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchStaffProfiles(filters, token);
    return response;
  }
);

export const fetchClosureExpectedStatsData = createAsyncThunk(
  "prospects/fetchClosureExpectedStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchClosureExpectedStats(filters, token);
    return response;
  }
);

export const fetchRedFlagsData = createAsyncThunk(
  "prospects/fetchRedFlagsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchRedFlags(filters, token);
    return response;
  }
);

export const fetchVisitSuccessMetricsData = createAsyncThunk(
  "prospects/fetchVisitSuccessMetricsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchVisitSuccessMetrics(filters, token);
    return response;
  }
);

export const fetchRecentGymActivityData = createAsyncThunk(
  "prospects/fetchRecentGymActivityData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchRecentGymActivity(filters, token);
    return response;
  }
);

export const fetchPipelineStatsData = createAsyncThunk(
  "prospects/fetchPipelineStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchPipelineStats(filters, token);
    return response;
  }
);

export const fetchClosurePipelineCriticalTrackingData = createAsyncThunk(
  "prospects/fetchClosurePipelineCriticalTrackingData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchClosurePipelineCriticalTracking(filters, token);
    return response;
  }
);

export const fetchClosurePipelineCriticalTrackingOverviewData =
  createAsyncThunk(
    "prospects/fetchClosurePipelineCriticalTrackingOverviewData",
    async (payload, { getState }) => {
      const { filters, token } = payload;
      const response = await fetchClosurePipelineCriticalTrackingOverview(
        filters,
        token
      );
      return response;
    }
  );

export const fetchClosureExpectedDeepTrackerData = createAsyncThunk(
  "prospects/fetchClosureExpectedDeepTrackerData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchClosureExpectedDeepTracker(filters, token);
    return response;
  }
);

export const fetchDeepTrackerTimelineViewData = createAsyncThunk(
  "prospects/fetchDeepTrackerTimelineViewData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchDeepTrackerTimelineView(filters, token);
    return response;
  }
);

export const fetchClosurePatternAnalysisData = createAsyncThunk(
  "prospects/fetchClosurePatternAnalysisData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchClosurePatternAnalysis(filters, token);
    return response;
  }
);

export const fetchDailyLeadMovementStatsData = createAsyncThunk(
  "prospects/fetchDailyLeadMovementStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchDailyLeadMovementStats(filters, token);
    return response;
  }
);

export const fetchAgentManagementData = createAsyncThunk(
  "prospects/fetchAgentManagementData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAgentManagement(filters, token);
    return response;
  }
);

export const fetchAcademyLeadsData = createAsyncThunk(
  "prospects/fetchAcademyLeadsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAcademyLeads(filters, token);
    return response;
  }
);

export const fetchStaffAttendanceStatsData = createAsyncThunk(
  "prospects/fetchStaffAttendanceStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchStaffAttendanceStats(filters, token);
    return response;
  }
);

export const fetchMemberCheckinMetricsData = createAsyncThunk(
  "prospects/fetchMemberCheckinMetricsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchMemberCheckinMetrics(filters, token);
    return response;
  }
);

export const fetchGymwiseCheckinMetricsData = createAsyncThunk(
  "prospects/fetchGymwiseCheckinMetricsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymwiseCheckinMetrics(filters, token);
    return response;
  }
);

export const fetchGymCardStatsData = createAsyncThunk(
  "prospects/fetchGymCardStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymCardStats(filters, token);
    return response;
  }
);

export const fetchGymDistributionStatsData = createAsyncThunk(
  "prospects/fetchGymDistributionStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymDistributionStats(filters, token);
    return response;
  }
);

export const fetchGymSegmentMembersBPData = createAsyncThunk(
  "prospects/fetchGymSegmentMembersBPData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymSegmentMembers(filters, token);
    return response;
  }
);

export const fetchGymSegmentMembersTrialData = createAsyncThunk(
  "prospects/fetchGymSegmentMembersTrialData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymSegmentMembers(filters, token);
    return response;
  }
);

export const fetchGymSegmentMembersUnassignedData = createAsyncThunk(
  "prospects/fetchGymSegmentMembersUnassignedData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymSegmentMembers(filters, token);
    return response;
  }
);

export const fetchSegmentMembersData = createAsyncThunk(
  "prospects/fetchSegmentMembersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymSegmentMembers(filters, token);
    return response;
  }
);

export const fetchFreshLeadsV2Data = createAsyncThunk(
  "prospects/fetchFreshLeadsV2Data",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchFreshLeadsV2(filters, token);
    return response;
  }
);

export const fetchRegularizationRequestData = createAsyncThunk(
  "prospects/fetchRegularizationRequestData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchRegularizationRequest(filters, token);
    return response;
  }
);

export const fetchTMEGymwiseAnalysisData = createAsyncThunk(
  "prospects/fetchTMEGymwiseAnalysisData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTMEGymwiseAnalysis(filters, token);
    return response;
  }
);

export const fetchTMECheckinAnalysisData = createAsyncThunk(
  "prospects/fetchTMECheckinAnalysisData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTMECheckinAnalysis(filters, token);
    return response;
  }
);

export const fetchTMECheckinBreakdownData = createAsyncThunk(
  "prospects/fetchTMECheckinBreakdownData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTMECheckinBreakdown(filters, token);
    return response;
  }
);

export const fetchTMECheckinTimelineData = createAsyncThunk(
  "prospects/fetchTMECheckinTimelineData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTMECheckinTimeline(filters, token);
    return response;
  }
);

export const fetchExpiredMembersData = createAsyncThunk(
  "prospects/fetchExpiredMembersData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchExpiredMembers(filters, token);
    return response;
  }
);

export const fetchGymRetentionStatsData = createAsyncThunk(
  "prospects/fetchGymRetentionStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymRetentionStats(filters, token);
    return response;
  }
);

export const fetchMemberWeightData = createAsyncThunk(
  "prospects/fetchMemberWeightData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchMemberWeight(filters, token);
    return response;
  }
);

export const fetchBMIChartData = createAsyncThunk(
  "prospects/fetchBMIChartData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchBMIChart(filters, token);
    return response;
  }
);

export const fetchHealthTrackingData = createAsyncThunk(
  "prospects/fetchHealthTrackingData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchHealthTracking(filters, token);
    return response;
  }
);

export const fetchWTF360ConsultationsData = createAsyncThunk(
  "prospects/fetchWTF360ConsultationsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchWTF360Consultations(filters, token);
    return response;
  }
);

export const fetchDiscountApprovalAccessData = createAsyncThunk(
  "prospects/fetchDiscountApprovalAccessData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchDiscountApprovalAccess(filters, token);
    return response;
  }
);

export const fetchCallLogsData = createAsyncThunk(
  "prospects/fetchCallLogsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchCallLogs(filters, token);
    return response;
  }
);

export const fetchTrainerStatsData = createAsyncThunk(
  "prospects/fetchTrainerStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTrainerStats(filters, token);
    return response;
  }
);

export const fetchTrainerStatsDetailsData = createAsyncThunk(
  "prospects/fetchTrainerStatsDetailsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTrainerStatsDetails(filters, token);
    return response;
  }
);

export const fetchWTF360InquiryData = createAsyncThunk(
  "prospects/fetchWTF360InquiryData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchWTF360Inquiry(filters, token);
    return response;
  }
);

export const fetchPreSaleGymLeadsData = createAsyncThunk(
  "prospects/fetchPreSaleGymLeadsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchPreSaleGymLeads(filters, token);
    return response;
  }
);

const prospectSlice = createSlice({
  name: "prospects",
  initialState: {
    ptProspectsStats: null,
    ptProspectsStatsError: "",
    ptProspectsStatsLoading: false,

    ptProspectsLists: null,
    ptProspectsError: "",
    ptProspectsLoading: false,

    fdDfPaymentEnable: null,
    fdDfPaymentEnableError: "",
    fdDfPaymentEnableLoading: false,

    fdDiscountPaymentEnable: null,
    fdDiscountPaymentEnableError: "",
    fdDiscountPaymentEnableLoading: false,

    fdPaymentLinkAccess: null,
    fdPaymentLinkAccessError: "",
    fdPaymentLinkAccessLoading: false,

    referralStat: null,
    referralStatLoading: false,
    referralStatError: null,

    referrals: null,
    referralsError: "",
    referralsLoading: false,

    tmeApprovalManager: null,
    tmeApprovalManagerLoading: false,
    tmeApprovalManagerError: null,

    agentTargetStats: null,
    agentTargetStatsLoading: false,
    agentTargetStatsError: null,

    agentsDailyTargte: null,
    agentsDailyTargteLoading: false,
    agentsDailyTargteError: null,

    agentWeeklyReport: null,
    agentWeeklyReportLoading: false,
    agentWeeklyReportError: null,

    checkedInMembers: null,
    checkedInMembersLoading: false,
    checkedInMembersError: null,

    vendorsBTL: null,
    vendorsBTLLoading: false,
    vendorsBTLError: null,

    leadsBTL: null,
    leadsBTLLoading: false,
    leadsBTLError: null,

    staffOnboardingRequests: null,
    staffOnboardingRequestsLoading: false,
    staffOnboardingRequestsError: null,

    deletedStaff: null,
    deletedStaffLoading: false,
    deletedStaffError: null,
    staffOffboarding: null,
    staffOffboardingLoading: false,
    staffOffboardingError: null,

    receptionists: null,
    receptionistsLoading: false,
    receptionistsError: null,

    gymKeywordStats: null,
    gymKeywordStatsLoading: false,
    gymKeywordStatsError: null,

    gymAutomationKeywords: null,
    gymAutomationKeywordsLoading: false,
    gymAutomationKeywordsError: null,

    cashReports: null,
    cashReportsLoading: false,
    cashReportsError: null,

    walkinLeads: null,
    walkinLeadsLoading: false,
    walkinLeadsError: null,

    fitnessProfileLogs: null,
    fitnessProfileLogsLoading: false,
    fitnessProfileLogsError: null,

    fitnessProfileStats: null,
    fitnessProfileStatsLoading: false,
    fitnessProfileStatsError: null,

    bcaLogs: null,
    bcaLogsLoading: false,
    bcaLogsError: null,

    bcaStats: null,
    bcaStatsLoading: false,
    bcaStatsError: null,

    leadTimeline: null,
    leadTimelineLoading: false,
    leadTimelineError: null,

    leadCycle: null,
    leadCycleLoading: false,
    leadCycleError: null,

    lmsFollowups: null,
    lmsFollowupsLoading: false,
    lmsFollowupsError: null,

    waitGymwise: null,
    waitGymwiseLoading: false,
    waitGymwiseError: null,

    freshLeads: null,
    freshLeadsLoading: false,
    freshLeadsError: null,

    staffProfiles: null,
    staffProfilesLoading: false,
    staffProfilesError: null,

    closureExpectedStats: null,
    closureExpectedStatsLoading: false,
    closureExpectedStatsError: null,

    redFlags: null,
    redFlagsLoading: false,
    redFlagsError: null,

    visitSuccessMetrics: null,
    visitSuccessMetricsLoading: false,
    visitSuccessMetricsError: null,

    recentGymActivity: null,
    recentGymActivityLoading: false,
    recentGymActivityError: null,

    pipelineStats: null,
    pipelineStatsLoading: false,
    pipelineStatsError: null,

    closurePipelineCriticalTracking: null,
    closurePipelineCriticalTrackingLoading: false,
    closurePipelineCriticalTrackingError: null,

    closurePipelineCriticalTrackingOverview: null,
    closurePipelineCriticalTrackingOverviewLoading: false,
    closurePipelineCriticalTrackingOverviewError: null,

    closureExpectedDeepTracker: null,
    closureExpectedDeepTrackerLoading: false,
    closureExpectedDeepTrackerError: null,

    deepTrackerTimelineView: null,
    deepTrackerTimelineViewLoading: false,
    deepTrackerTimelineViewError: null,

    closurePatternAnalysis: null,
    closurePatternAnalysisLoading: false,
    closurePatternAnalysisError: null,

    dailyLeadMovementStats: null,
    dailyLeadMovementStatsLoading: false,
    dailyLeadMovementStatsError: null,

    agentManagement: null,
    agentManagementLoading: false,
    agentManagementError: null,

    academyLeads: null,
    academyLeadsLoading: false,
    academyLeadsError: null,

    staffAttendanceStats: null,
    staffAttendanceStatsLoading: false,
    staffAttendanceStatsError: null,

    memberCheckinMetrics: null,
    memberCheckinMetricsLoading: false,
    memberCheckinMetricsError: null,

    gymwiseCheckinMetrics: null,
    gymwiseCheckinMetricsLoading: false,
    gymwiseCheckinMetricsError: null,

    gymCardStats: null,
    gymCardStatsLoading: false,
    gymCardStatsError: null,

    gymDistributionStats: null,
    gymDistributionStatsLoading: false,
    gymDistributionStatsError: null,

    gymSegmentMembersBP: null,
    gymSegmentMembersBPLoading: false,
    gymSegmentMembersBPError: null,

    gymSegmentMembersTrial: null,
    gymSegmentMembersTrialLoading: false,
    gymSegmentMembersTrialError: null,

    gymSegmentMembersUnassigned: null,
    gymSegmentMembersUnassignedLoading: false,
    gymSegmentMembersUnassignedError: null,

    segmentMembers: null,
    segmentMembersLoading: false,
    segmentMembersError: null,

    freshLeadsV2: null,
    freshLeadsV2Loading: false,
    freshLeadsV2Error: null,

    regularizationRequest: null,
    regularizationRequestError: null,
    regularizationRequestLoading: false,

    tmeGymwiseAnalysis: null,
    tmeGymwiseAnalysisError: null,
    tmeGymwiseAnalysisLoading: false,

    tmeCheckinAnalysis: null,
    tmeCheckinAnalysisError: null,
    tmeCheckinAnalysisLoading: false,

    tmeCheckinBreakdown: null,
    tmeCheckinBreakdownError: null,
    tmeCheckinBreakdownLoading: false,

    tmeCheckinTimeline: null,
    tmeCheckinTimelineError: null,
    tmeCheckinTimelineLoading: false,

    expiredMembers: null,
    expiredMembersError: null,
    expiredMembersLoading: false,

    gymRetentionStats: null,
    gymRetentionStatsError: null,
    gymRetentionStatsLoading: false,

    memberWeight: null,
    memberWeightError: null,
    memberWeightLoading: false,

    bmiChart: null,
    bmiChartError: null,
    bmiChartLoading: false,

    healthTracking: null,
    healthTrackingError: null,
    healthTrackingLoading: false,

    wtf360Consultations: null,
    wtf360ConsultationsError: null,
    wtf360ConsultationsLoading: false,

    discountApprovalAccess: null,
    discountApprovalAccessError: null,
    discountApprovalAccessLoading: false,

    callLogsData: null,
    callLogsError: null,
    callLogsLoading: false,

    trainerStatsData: null,
    trainerStatsError: null,
    trainerStatsLoading: false,

    trainerStatsDetailsData: null,
    trainerStatsDetailsError: null,
    trainerStatsDetailsLoading: false,

    wtf360Inquiry: null,
    wtf360InquiryError: null,
    wtf360InquiryLoading: false,

    preSaleGymLeads: null,
    preSaleGymLeadsError: null,
    preSaleGymLeadsLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPtProspectsStatsData.pending, (state) => {
        state.ptProspectsStatsLoading = true;
      })
      .addCase(fetchPtProspectsStatsData.fulfilled, (state, action) => {
        state.ptProspectsStatsLoading = false;
        state.ptProspectsStats = action.payload;
      })
      .addCase(fetchPtProspectsStatsData.rejected, (state, action) => {
        state.ptProspectsStatsLoading = false;
        state.ptProspectsStatsError = action.error.message;
      })

      .addCase(fetchPtProspectsData.pending, (state) => {
        state.ptProspectsLoading = true;
      })
      .addCase(fetchPtProspectsData.fulfilled, (state, action) => {
        state.ptProspectsLoading = false;
        state.ptProspectsLists = action.payload;
      })
      .addCase(fetchPtProspectsData.rejected, (state, action) => {
        state.ptProspectsLoading = false;
        state.ptProspectsError = action.error.message;
      })

      .addCase(fetchFDDFPaymentCreationData.pending, (state) => {
        state.fdDfPaymentEnableLoading = true;
      })
      .addCase(fetchFDDFPaymentCreationData.fulfilled, (state, action) => {
        state.fdDfPaymentEnableLoading = false;
        state.fdDfPaymentEnable = action.payload;
      })
      .addCase(fetchFDDFPaymentCreationData.rejected, (state, action) => {
        state.fdDfPaymentEnableLoading = false;
        state.fdDfPaymentEnableError = action.error.message;
      })

      .addCase(fetchDiscountPaymentCreationData.pending, (state) => {
        state.fdDiscountPaymentEnableLoading = true;
      })
      .addCase(fetchDiscountPaymentCreationData.fulfilled, (state, action) => {
        state.fdDiscountPaymentEnableLoading = false;
        state.fdDiscountPaymentEnable = action.payload;
      })
      .addCase(fetchDiscountPaymentCreationData.rejected, (state, action) => {
        state.fdDiscountPaymentEnableLoading = false;
        state.fdDiscountPaymentEnableError = action.error.message;
      })

      .addCase(fetchFDDPaymentLinkAccessData.pending, (state) => {
        state.fdPaymentLinkAccessLoading = true;
      })
      .addCase(fetchFDDPaymentLinkAccessData.fulfilled, (state, action) => {
        state.fdPaymentLinkAccessLoading = false;
        state.fdPaymentLinkAccess = action.payload;
      })
      .addCase(fetchFDDPaymentLinkAccessData.rejected, (state, action) => {
        state.fdPaymentLinkAccessLoading = false;
        state.fdPaymentLinkAccessError = action.error.message;
      })

      .addCase(fetchReferralsData.pending, (state) => {
        state.referralsLoading = true;
      })
      .addCase(fetchReferralsData.fulfilled, (state, action) => {
        state.referralsLoading = false;
        state.referrals = action.payload;
      })
      .addCase(fetchReferralsData.rejected, (state, action) => {
        state.referralsLoading = false;
        state.referralsError = action.error.message;
      })

      .addCase(fetchTMEApprovalManagerData.pending, (state) => {
        state.tmeApprovalManagerLoading = true;
      })
      .addCase(fetchTMEApprovalManagerData.fulfilled, (state, action) => {
        state.tmeApprovalManagerLoading = false;
        state.tmeApprovalManager = action.payload;
      })
      .addCase(fetchTMEApprovalManagerData.rejected, (state, action) => {
        state.tmeApprovalManagerLoading = false;
        state.tmeApprovalManagerError = action.error.message;
      })

      .addCase(fetchAgentTargetStatsData.pending, (state) => {
        state.agentTargetStatsLoading = true;
      })
      .addCase(fetchAgentTargetStatsData.fulfilled, (state, action) => {
        state.agentTargetStatsLoading = false;
        state.agentTargetStats = action.payload;
      })
      .addCase(fetchAgentTargetStatsData.rejected, (state, action) => {
        state.agentTargetStatsLoading = false;
        state.agentTargetStatsError = action.error.message;
      })

      .addCase(fetchAgentDailyTargetata.pending, (state) => {
        state.agentsDailyTargteLoading = true;
      })
      .addCase(fetchAgentDailyTargetata.fulfilled, (state, action) => {
        state.agentsDailyTargteLoading = false;
        state.agentsDailyTargte = action.payload;
      })
      .addCase(fetchAgentDailyTargetata.rejected, (state, action) => {
        state.agentsDailyTargteLoading = false;
        state.agentsDailyTargteError = action.error.message;
      })

      .addCase(fetchAgentWeeklyTargetData.pending, (state) => {
        state.agentWeeklyReportLoading = true;
      })
      .addCase(fetchAgentWeeklyTargetData.fulfilled, (state, action) => {
        state.agentWeeklyReportLoading = false;
        state.agentWeeklyReport = action.payload;
      })
      .addCase(fetchAgentWeeklyTargetData.rejected, (state, action) => {
        state.agentWeeklyReportLoading = false;
        state.agentWeeklyReportError = action.error.message;
      })

      .addCase(fetchCheckedInMembersData.pending, (state) => {
        state.checkedInMembersLoading = true;
      })
      .addCase(fetchCheckedInMembersData.fulfilled, (state, action) => {
        state.checkedInMembersLoading = false;
        state.checkedInMembers = action.payload;
      })
      .addCase(fetchCheckedInMembersData.rejected, (state, action) => {
        state.checkedInMembersLoading = false;
        state.checkedInMembersError = action.error.message;
      })

      .addCase(fetchBTLVendorsData.pending, (state) => {
        state.vendorsBTLLoading = true;
      })
      .addCase(fetchBTLVendorsData.fulfilled, (state, action) => {
        state.vendorsBTLLoading = false;
        state.vendorsBTL = action.payload;
      })
      .addCase(fetchBTLVendorsData.rejected, (state, action) => {
        state.vendorsBTLLoading = false;
        state.vendorsBTLError = action.error.message;
      })

      .addCase(fetchBTLLeadsData.pending, (state) => {
        state.leadsBTLLoading = true;
      })
      .addCase(fetchBTLLeadsData.fulfilled, (state, action) => {
        state.leadsBTLLoading = false;
        state.leadsBTL = action.payload;
      })
      .addCase(fetchBTLLeadsData.rejected, (state, action) => {
        state.leadsBTLLoading = false;
        state.leadsBTLError = action.error.message;
      })

      .addCase(fetchStaffOnboardingRequestsData.pending, (state) => {
        state.staffOnboardingRequestsLoading = true;
        state.staffOnboardingRequestsError = null;
      })
      .addCase(fetchStaffOnboardingRequestsData.fulfilled, (state, action) => {
        state.staffOnboardingRequestsLoading = false;
        state.staffOnboardingRequestsError = null;
        state.staffOnboardingRequests = action.payload;
      })
      .addCase(fetchStaffOnboardingRequestsData.rejected, (state, action) => {
        state.staffOnboardingRequestsLoading = false;
        state.staffOnboardingRequestsError = action.error.message;
      })

      .addCase(fetchDeletedStaffData.pending, (state) => {
        state.deletedStaffLoading = true;
      })
      .addCase(fetchDeletedStaffData.fulfilled, (state, action) => {
        state.deletedStaffLoading = false;
        state.deletedStaff = action.payload;
      })
      .addCase(fetchStaffOffboardingData.pending, (state) => {
        state.staffOffboardingLoading = true;
      })
      .addCase(fetchStaffOffboardingData.fulfilled, (state, action) => {
        state.staffOffboardingLoading = false;
        state.staffOffboarding = action.payload;
      })
      .addCase(fetchStaffOffboardingData.rejected, (state, action) => {
        state.staffOffboardingLoading = false;
        state.staffOffboardingError = action.error.message;
      })
      .addCase(fetchDeletedStaffData.rejected, (state, action) => {
        state.deletedStaffLoading = false;
        state.deletedStaffError = action.error.message;
      })

      .addCase(fetchReceptionistsData.pending, (state) => {
        state.receptionistsLoading = true;
      })
      .addCase(fetchReceptionistsData.fulfilled, (state, action) => {
        state.receptionistsLoading = false;
        state.receptionists = action.payload;
      })
      .addCase(fetchReceptionistsData.rejected, (state, action) => {
        state.receptionistsLoading = false;
        state.receptionistsError = action.error.message;
      })

      .addCase(fetchReferralStatData.pending, (state) => {
        state.referralStatLoading = true;
      })
      .addCase(fetchReferralStatData.fulfilled, (state, action) => {
        state.referralStatLoading = false;
        state.referralStat = action.payload;
      })
      .addCase(fetchReferralStatData.rejected, (state, action) => {
        state.referralStatLoading = false;
        state.referralStatError = action.error.message;
      })

      .addCase(fetchGymKeywordStatsData.pending, (state) => {
        state.gymKeywordStatsLoading = true;
      })
      .addCase(fetchGymKeywordStatsData.fulfilled, (state, action) => {
        state.gymKeywordStatsLoading = false;
        state.gymKeywordStats = action.payload;
      })
      .addCase(fetchGymKeywordStatsData.rejected, (state, action) => {
        state.gymKeywordStatsLoading = false;
        state.gymKeywordStatsError = action.error.message;
      })

      .addCase(fetchGymKeywordsData.pending, (state) => {
        state.gymAutomationKeywordsLoading = true;
      })
      .addCase(fetchGymKeywordsData.fulfilled, (state, action) => {
        state.gymAutomationKeywordsLoading = false;
        state.gymAutomationKeywords = action.payload;
      })
      .addCase(fetchGymKeywordsData.rejected, (state, action) => {
        state.gymAutomationKeywordsLoading = false;
        state.gymAutomationKeywordsError = action.error.message;
      })

      .addCase(fetchCashReportsData.pending, (state) => {
        state.cashReportsLoading = true;
      })
      .addCase(fetchCashReportsData.fulfilled, (state, action) => {
        state.cashReportsLoading = false;
        state.cashReports = action.payload;
      })
      .addCase(fetchCashReportsData.rejected, (state, action) => {
        state.cashReportsLoading = false;
        state.cashReportsError = action.error.message;
      })

      .addCase(fetchWalkinLeadsData.pending, (state) => {
        state.walkinLeadsLoading = true;
      })
      .addCase(fetchWalkinLeadsData.fulfilled, (state, action) => {
        state.walkinLeadsLoading = false;
        state.walkinLeads = action.payload;
      })
      .addCase(fetchWalkinLeadsData.rejected, (state, action) => {
        state.walkinLeadsLoading = false;
        state.walkinLeadsError = action.error.message;
      })

      .addCase(fetchFitnessProfileLogsData.pending, (state) => {
        state.fitnessProfileLogsLoading = true;
        state.fitnessProfileLogs = null;
        state.fitnessProfileLogsError = null;
      })
      .addCase(fetchFitnessProfileLogsData.fulfilled, (state, action) => {
        state.fitnessProfileLogsLoading = false;
        state.fitnessProfileLogs = action.payload;
      })
      .addCase(fetchFitnessProfileLogsData.rejected, (state, action) => {
        state.fitnessProfileLogsLoading = false;
        state.fitnessProfileLogsError = action.error.message;
      })

      .addCase(fetchFitnessProfileStatsData.pending, (state) => {
        state.fitnessProfileStatsLoading = true;
        state.fitnessProfileStatsError = null;
      })
      .addCase(fetchFitnessProfileStatsData.fulfilled, (state, action) => {
        state.fitnessProfileStatsLoading = false;
        state.fitnessProfileStats = action.payload;
      })
      .addCase(fetchFitnessProfileStatsData.rejected, (state, action) => {
        state.fitnessProfileStatsLoading = false;
        state.fitnessProfileStatsError = action.error.message;
      })

      .addCase(fetchBCALogsData.pending, (state) => {
        state.bcaLogsLoading = true;
      })
      .addCase(fetchBCALogsData.fulfilled, (state, action) => {
        state.bcaLogsLoading = false;
        state.bcaLogs = action.payload;
      })
      .addCase(fetchBCALogsData.rejected, (state, action) => {
        state.bcaLogsLoading = false;
        state.bcaLogsError = action.error.message;
      })

      .addCase(fetchBCAStatsData.pending, (state) => {
        state.bcaStatsLoading = true;
        state.bcaStatsError = null;
      })
      .addCase(fetchBCAStatsData.fulfilled, (state, action) => {
        state.bcaStatsLoading = false;
        state.bcaStats = action.payload;
      })
      .addCase(fetchBCAStatsData.rejected, (state, action) => {
        state.bcaStatsLoading = false;
        state.bcaStatsError = action.error.message;
      })

      .addCase(fetchLeadTimelineData.pending, (state) => {
        state.leadTimelineLoading = true;
      })
      .addCase(fetchLeadTimelineData.fulfilled, (state, action) => {
        state.leadTimelineLoading = false;
        state.leadTimeline = action.payload;
      })
      .addCase(fetchLeadTimelineData.rejected, (state, action) => {
        state.leadTimelineLoading = false;
        state.leadTimelineError = action.error.message;
      })

      .addCase(fetchLeadCycleData.pending, (state) => {
        state.leadCycleLoading = true;
      })
      .addCase(fetchLeadCycleData.fulfilled, (state, action) => {
        state.leadCycleLoading = false;
        state.leadCycle = action.payload;
      })
      .addCase(fetchLeadCycleData.rejected, (state, action) => {
        state.leadCycleLoading = false;
        state.leadCycleError = action.error.message;
      })

      .addCase(fetchLMSFollowupsData.pending, (state) => {
        state.lmsFollowupsLoading = true;
        state.lmsFollowupsError = null;
      })
      .addCase(fetchLMSFollowupsData.fulfilled, (state, action) => {
        state.lmsFollowupsLoading = false;
        state.lmsFollowupsError = null;
        state.lmsFollowups = action.payload;
      })
      .addCase(fetchLMSFollowupsData.rejected, (state, action) => {
        state.lmsFollowupsLoading = false;
        state.lmsFollowupsError = action.error.message;
      })

      .addCase(fetchWaitGymwiseData.pending, (state) => {
        state.waitGymwiseLoading = true;
        state.waitGymwise = null;
        state.waitGymwiseError = null;
      })
      .addCase(fetchWaitGymwiseData.fulfilled, (state, action) => {
        state.waitGymwiseLoading = false;
        state.waitGymwise = action.payload;
      })
      .addCase(fetchWaitGymwiseData.rejected, (state, action) => {
        state.waitGymwiseLoading = false;
        state.waitGymwiseError = action.error.message;
      })

      .addCase(fetchFreshLeadsData.pending, (state) => {
        state.freshLeadsLoading = true;
      })
      .addCase(fetchFreshLeadsData.fulfilled, (state, action) => {
        state.freshLeadsLoading = false;
        state.freshLeads = action.payload;
      })
      .addCase(fetchFreshLeadsData.rejected, (state, action) => {
        state.freshLeadsLoading = false;
        state.freshLeadsError = action.error.message;
      })

      .addCase(fetchStaffProfilesData.pending, (state) => {
        state.staffProfilesLoading = true;
      })
      .addCase(fetchStaffProfilesData.fulfilled, (state, action) => {
        state.staffProfilesLoading = false;
        state.staffProfiles = action.payload;
      })
      .addCase(fetchStaffProfilesData.rejected, (state, action) => {
        state.staffProfilesLoading = false;
        state.staffProfilesError = action.error.message;
      })

      .addCase(fetchClosureExpectedStatsData.pending, (state) => {
        state.closureExpectedStatsLoading = true;
        state.closureExpectedStatsError = null;
      })
      .addCase(fetchClosureExpectedStatsData.fulfilled, (state, action) => {
        state.closureExpectedStatsLoading = false;
        state.closureExpectedStatsError = null;
        state.closureExpectedStats = action.payload;
      })
      .addCase(fetchClosureExpectedStatsData.rejected, (state, action) => {
        state.closureExpectedStatsLoading = false;
        state.closureExpectedStatsError = action.error.message;
      })

      .addCase(fetchRedFlagsData.pending, (state) => {
        state.redFlagsLoading = true;
        state.redFlagsError = null;
      })
      .addCase(fetchRedFlagsData.fulfilled, (state, action) => {
        state.redFlagsLoading = false;
        state.redFlagsError = null;
        state.redFlags = action.payload;
      })
      .addCase(fetchRedFlagsData.rejected, (state, action) => {
        state.redFlagsLoading = false;
        state.redFlagsError = action.error.message;
      })

      .addCase(fetchVisitSuccessMetricsData.pending, (state) => {
        state.visitSuccessMetricsLoading = true;
        state.visitSuccessMetricsError = null;
      })
      .addCase(fetchVisitSuccessMetricsData.fulfilled, (state, action) => {
        state.visitSuccessMetricsLoading = false;
        state.visitSuccessMetricsError = null;
        state.visitSuccessMetrics = action.payload;
      })
      .addCase(fetchVisitSuccessMetricsData.rejected, (state, action) => {
        state.visitSuccessMetricsLoading = false;
        state.visitSuccessMetricsError = action.error.message;
      })

      .addCase(fetchRecentGymActivityData.pending, (state) => {
        state.recentGymActivityLoading = true;
        state.recentGymActivityError = null;
      })
      .addCase(fetchRecentGymActivityData.fulfilled, (state, action) => {
        state.recentGymActivityLoading = false;
        state.recentGymActivityError = null;
        state.recentGymActivity = action.payload;
      })
      .addCase(fetchRecentGymActivityData.rejected, (state, action) => {
        state.recentGymActivityLoading = false;
        state.recentGymActivityError = action.error.message;
      })

      .addCase(fetchPipelineStatsData.pending, (state) => {
        state.pipelineStatsLoading = true;
        state.pipelineStatsError = null;
      })
      .addCase(fetchPipelineStatsData.fulfilled, (state, action) => {
        state.pipelineStatsLoading = false;
        state.pipelineStatsError = null;
        state.pipelineStats = action.payload;
      })
      .addCase(fetchPipelineStatsData.rejected, (state, action) => {
        state.pipelineStatsLoading = false;
        state.pipelineStatsError = action.error.message;
      })

      .addCase(fetchClosurePipelineCriticalTrackingData.pending, (state) => {
        state.closurePipelineCriticalTrackingLoading = true;
        state.closurePipelineCriticalTrackingError = null;
      })
      .addCase(
        fetchClosurePipelineCriticalTrackingData.fulfilled,
        (state, action) => {
          state.closurePipelineCriticalTrackingLoading = false;
          state.closurePipelineCriticalTrackingError = null;
          state.closurePipelineCriticalTracking = action.payload;
        }
      )
      .addCase(
        fetchClosurePipelineCriticalTrackingData.rejected,
        (state, action) => {
          state.closurePipelineCriticalTrackingLoading = false;
          state.closurePipelineCriticalTrackingError = action.error.message;
        }
      )

      .addCase(
        fetchClosurePipelineCriticalTrackingOverviewData.pending,
        (state) => {
          state.closurePipelineCriticalTrackingOverviewLoading = true;
          state.closurePipelineCriticalTrackingOverviewError = null;
        }
      )
      .addCase(
        fetchClosurePipelineCriticalTrackingOverviewData.fulfilled,
        (state, action) => {
          state.closurePipelineCriticalTrackingOverviewLoading = false;
          state.closurePipelineCriticalTrackingOverviewError = null;
          state.closurePipelineCriticalTrackingOverview = action.payload;
        }
      )
      .addCase(
        fetchClosurePipelineCriticalTrackingOverviewData.rejected,
        (state, action) => {
          state.closurePipelineCriticalTrackingOverviewLoading = false;
          state.closurePipelineCriticalTrackingOverviewError =
            action.error.message;
        }
      )

      .addCase(fetchClosureExpectedDeepTrackerData.pending, (state) => {
        state.closureExpectedDeepTrackerLoading = true;
        state.closureExpectedDeepTrackerError = null;
      })
      .addCase(
        fetchClosureExpectedDeepTrackerData.fulfilled,
        (state, action) => {
          state.closureExpectedDeepTrackerLoading = false;
          state.closureExpectedDeepTrackerError = null;
          state.closureExpectedDeepTracker = action.payload;
        }
      )
      .addCase(
        fetchClosureExpectedDeepTrackerData.rejected,
        (state, action) => {
          state.closureExpectedDeepTrackerLoading = false;
          state.closureExpectedDeepTrackerError = action.error.message;
        }
      )

      .addCase(fetchDeepTrackerTimelineViewData.pending, (state) => {
        state.deepTrackerTimelineViewLoading = true;
        state.deepTrackerTimelineViewError = null;
      })
      .addCase(fetchDeepTrackerTimelineViewData.fulfilled, (state, action) => {
        state.deepTrackerTimelineViewLoading = false;
        state.deepTrackerTimelineViewError = null;
        state.deepTrackerTimelineView = action.payload;
      })
      .addCase(fetchDeepTrackerTimelineViewData.rejected, (state, action) => {
        state.deepTrackerTimelineViewLoading = false;
        state.deepTrackerTimelineViewError = action.error.message;
      })

      .addCase(fetchClosurePatternAnalysisData.pending, (state) => {
        state.closurePatternAnalysisLoading = true;
        state.closurePatternAnalysisError = null;
      })
      .addCase(fetchClosurePatternAnalysisData.fulfilled, (state, action) => {
        state.closurePatternAnalysisLoading = false;
        state.closurePatternAnalysisError = null;
        state.closurePatternAnalysis = action.payload;
      })
      .addCase(fetchClosurePatternAnalysisData.rejected, (state, action) => {
        state.closurePatternAnalysisLoading = false;
        state.closurePatternAnalysisError = action.error.message;
      })

      .addCase(fetchDailyLeadMovementStatsData.pending, (state) => {
        state.dailyLeadMovementStatsLoading = true;
        state.dailyLeadMovementStatsError = null;
      })
      .addCase(fetchDailyLeadMovementStatsData.fulfilled, (state, action) => {
        state.dailyLeadMovementStatsLoading = false;
        state.dailyLeadMovementStatsError = null;
        state.dailyLeadMovementStats = action.payload;
      })
      .addCase(fetchDailyLeadMovementStatsData.rejected, (state, action) => {
        state.dailyLeadMovementStatsLoading = false;
        state.dailyLeadMovementStatsError = action.error.message;
      })

      .addCase(fetchAgentManagementData.pending, (state) => {
        state.agentManagementLoading = true;
        state.agentManagementError = null;
      })
      .addCase(fetchAgentManagementData.fulfilled, (state, action) => {
        state.agentManagementLoading = false;
        state.agentManagementError = null;
        state.agentManagement = action.payload;
      })
      .addCase(fetchAgentManagementData.rejected, (state, action) => {
        state.agentManagementLoading = false;
        state.agentManagementError = action.error.message;
      })

      .addCase(fetchAcademyLeadsData.pending, (state) => {
        state.academyLeadsLoading = true;
        state.academyLeadsError = null;
      })
      .addCase(fetchAcademyLeadsData.fulfilled, (state, action) => {
        state.academyLeadsLoading = false;
        state.academyLeadsError = null;
        state.academyLeads = action.payload;
      })
      .addCase(fetchAcademyLeadsData.rejected, (state, action) => {
        state.academyLeadsLoading = false;
        state.academyLeadsError = action.error.message;
      })

      .addCase(fetchStaffAttendanceStatsData.pending, (state) => {
        state.staffAttendanceStatsLoading = true;
        state.staffAttendanceStatsError = null;
      })
      .addCase(fetchStaffAttendanceStatsData.fulfilled, (state, action) => {
        state.staffAttendanceStatsLoading = false;
        state.staffAttendanceStatsError = null;
        state.staffAttendanceStats = action.payload;
      })
      .addCase(fetchStaffAttendanceStatsData.rejected, (state, action) => {
        state.staffAttendanceStatsLoading = false;
        state.staffAttendanceStatsError = action.error.message;
      })

      .addCase(fetchMemberCheckinMetricsData.pending, (state) => {
        state.memberCheckinMetricsLoading = true;
        state.memberCheckinMetricsError = null;
      })
      .addCase(fetchMemberCheckinMetricsData.fulfilled, (state, action) => {
        state.memberCheckinMetricsLoading = false;
        state.memberCheckinMetricsError = null;
        state.memberCheckinMetrics = action.payload;
      })
      .addCase(fetchMemberCheckinMetricsData.rejected, (state, action) => {
        state.memberCheckinMetricsLoading = false;
        state.memberCheckinMetricsError = action.error.message;
      })

      .addCase(fetchGymwiseCheckinMetricsData.pending, (state) => {
        state.gymwiseCheckinMetricsLoading = true;
        state.gymwiseCheckinMetricsError = null;
      })
      .addCase(fetchGymwiseCheckinMetricsData.fulfilled, (state, action) => {
        state.gymwiseCheckinMetricsLoading = false;
        state.gymwiseCheckinMetricsError = null;
        state.gymwiseCheckinMetrics = action.payload;
      })
      .addCase(fetchGymwiseCheckinMetricsData.rejected, (state, action) => {
        state.gymwiseCheckinMetricsLoading = false;
        state.gymwiseCheckinMetricsError = action.error.message;
      })

      .addCase(fetchGymCardStatsData.pending, (state) => {
        state.gymCardStatsLoading = true;
        state.gymCardStatsError = null;
      })
      .addCase(fetchGymCardStatsData.fulfilled, (state, action) => {
        state.gymCardStatsLoading = false;
        state.gymCardStatsError = null;
        state.gymCardStats = action.payload;
      })
      .addCase(fetchGymCardStatsData.rejected, (state, action) => {
        state.gymCardStatsLoading = false;
        state.gymCardStatsError = action.error.message;
      })

      .addCase(fetchGymDistributionStatsData.pending, (state) => {
        state.gymDistributionStatsLoading = true;
        state.gymDistributionStatsError = null;
      })
      .addCase(fetchGymDistributionStatsData.fulfilled, (state, action) => {
        state.gymDistributionStatsLoading = false;
        state.gymDistributionStatsError = null;
        state.gymDistributionStats = action.payload;
      })
      .addCase(fetchGymDistributionStatsData.rejected, (state, action) => {
        state.gymDistributionStatsLoading = false;
        state.gymDistributionStatsError = action.error.message;
      })

      .addCase(fetchGymSegmentMembersBPData.pending, (state) => {
        state.gymSegmentMembersBPLoading = true;
        state.gymSegmentMembersBPError = null;
      })
      .addCase(fetchGymSegmentMembersBPData.fulfilled, (state, action) => {
        state.gymSegmentMembersBPLoading = false;
        state.gymSegmentMembersBPError = null;
        state.gymSegmentMembersBP = action.payload;
      })
      .addCase(fetchGymSegmentMembersBPData.rejected, (state, action) => {
        state.gymSegmentMembersBPLoading = false;
        state.gymSegmentMembersBPError = action.error.message;
      })

      .addCase(fetchGymSegmentMembersTrialData.pending, (state) => {
        state.gymSegmentMembersTrialLoading = true;
        state.gymSegmentMembersTrialError = null;
      })
      .addCase(fetchGymSegmentMembersTrialData.fulfilled, (state, action) => {
        state.gymSegmentMembersTrialLoading = false;
        state.gymSegmentMembersTrialError = null;
        state.gymSegmentMembersTrial = action.payload;
      })
      .addCase(fetchGymSegmentMembersTrialData.rejected, (state, action) => {
        state.gymSegmentMembersTrialLoading = false;
        state.gymSegmentMembersTrialError = action.error.message;
      })

      .addCase(fetchGymSegmentMembersUnassignedData.pending, (state) => {
        state.gymSegmentMembersUnassignedLoading = true;
        state.gymSegmentMembersUnassignedError = null;
      })
      .addCase(
        fetchGymSegmentMembersUnassignedData.fulfilled,
        (state, action) => {
          state.gymSegmentMembersUnassignedLoading = false;
          state.gymSegmentMembersUnassignedError = null;
          state.gymSegmentMembersUnassigned = action.payload;
        }
      )
      .addCase(
        fetchGymSegmentMembersUnassignedData.rejected,
        (state, action) => {
          state.gymSegmentMembersUnassignedLoading = false;
          state.gymSegmentMembersUnassignedError = action.error.message;
        }
      )

      .addCase(fetchFreshLeadsV2Data.pending, (state) => {
        state.freshLeadsV2Loading = true;
        state.freshLeadsV2Error = null;
      })
      .addCase(fetchFreshLeadsV2Data.fulfilled, (state, action) => {
        state.freshLeadsV2Loading = false;
        state.freshLeadsV2Error = null;
        state.freshLeadsV2 = action.payload;
      })
      .addCase(fetchFreshLeadsV2Data.rejected, (state, action) => {
        state.freshLeadsV2Loading = false;
        state.freshLeadsV2Error = action.error.message;
      })

      .addCase(fetchRegularizationRequestData.pending, (state) => {
        state.regularizationRequestLoading = true;
        state.regularizationRequestError = null;
      })
      .addCase(fetchRegularizationRequestData.fulfilled, (state, action) => {
        state.regularizationRequestLoading = false;
        state.regularizationRequestError = null;
        state.regularizationRequest = action.payload;
      })
      .addCase(fetchRegularizationRequestData.rejected, (state, action) => {
        state.regularizationRequestLoading = false;
        state.regularizationRequestError = action.error.message;
      })

      .addCase(fetchTMEGymwiseAnalysisData.pending, (state) => {
        state.tmeGymwiseAnalysisLoading = true;
        state.tmeGymwiseAnalysisError = null;
      })
      .addCase(fetchTMEGymwiseAnalysisData.fulfilled, (state, action) => {
        state.tmeGymwiseAnalysisLoading = false;
        state.tmeGymwiseAnalysisError = null;
        state.tmeGymwiseAnalysis = action.payload;
      })
      .addCase(fetchTMEGymwiseAnalysisData.rejected, (state, action) => {
        state.tmeGymwiseAnalysisLoading = false;
        state.tmeGymwiseAnalysisError = action.error.message;
      })

      .addCase(fetchTMECheckinAnalysisData.pending, (state) => {
        state.tmeCheckinAnalysisLoading = true;
        state.tmeCheckinAnalysisError = null;
      })
      .addCase(fetchTMECheckinAnalysisData.fulfilled, (state, action) => {
        state.tmeCheckinAnalysisLoading = false;
        state.tmeCheckinAnalysisError = null;
        state.tmeCheckinAnalysis = action.payload;
      })
      .addCase(fetchTMECheckinAnalysisData.rejected, (state, action) => {
        state.tmeCheckinAnalysisLoading = false;
        state.tmeCheckinAnalysisError = action.error.message;
      })

      .addCase(fetchTMECheckinBreakdownData.pending, (state) => {
        state.tmeCheckinBreakdownLoading = true;
        state.tmeCheckinBreakdownError = null;
      })
      .addCase(fetchTMECheckinBreakdownData.fulfilled, (state, action) => {
        state.tmeCheckinBreakdownLoading = false;
        state.tmeCheckinBreakdownError = null;
        state.tmeCheckinBreakdown = action.payload;
      })
      .addCase(fetchTMECheckinBreakdownData.rejected, (state, action) => {
        state.tmeCheckinBreakdownLoading = false;
        state.tmeCheckinBreakdownError = action.error.message;
      })

      .addCase(fetchTMECheckinTimelineData.pending, (state) => {
        state.tmeCheckinTimelineLoading = true;
        state.tmeCheckinTimelineError = null;
      })
      .addCase(fetchTMECheckinTimelineData.fulfilled, (state, action) => {
        state.tmeCheckinTimelineLoading = false;
        state.tmeCheckinTimelineError = null;
        state.tmeCheckinTimeline = action.payload;
      })
      .addCase(fetchTMECheckinTimelineData.rejected, (state, action) => {
        state.tmeCheckinTimelineLoading = false;
        state.tmeCheckinTimelineError = action.error.message;
      })

      .addCase(fetchExpiredMembersData.pending, (state) => {
        state.expiredMembersLoading = true;
        state.expiredMembersError = null;
      })
      .addCase(fetchExpiredMembersData.fulfilled, (state, action) => {
        state.expiredMembersLoading = false;
        state.expiredMembersError = null;
        state.expiredMembers = action.payload;
      })
      .addCase(fetchExpiredMembersData.rejected, (state, action) => {
        state.expiredMembersLoading = false;
        state.expiredMembersError = action.error.message;
      })

      .addCase(fetchGymRetentionStatsData.pending, (state) => {
        state.gymRetentionStatsLoading = true;
        state.gymRetentionStatsError = null;
      })
      .addCase(fetchGymRetentionStatsData.fulfilled, (state, action) => {
        state.gymRetentionStatsLoading = false;
        state.gymRetentionStatsError = null;
        state.gymRetentionStats = action.payload;
      })
      .addCase(fetchGymRetentionStatsData.rejected, (state, action) => {
        state.gymRetentionStatsLoading = false;
        state.gymRetentionStatsError = action.error.message;
      })

      .addCase(fetchMemberWeightData.pending, (state) => {
        state.memberWeightLoading = true;
        state.memberWeightError = null;
      })
      .addCase(fetchMemberWeightData.fulfilled, (state, action) => {
        state.memberWeightLoading = false;
        state.memberWeightError = null;
        state.memberWeight = action.payload;
      })
      .addCase(fetchMemberWeightData.rejected, (state, action) => {
        state.memberWeightLoading = false;
        state.memberWeightError = action.error.message;
      })

      .addCase(fetchBMIChartData.pending, (state) => {
        state.bmiChartLoading = true;
        state.bmiChartError = null;
      })
      .addCase(fetchBMIChartData.fulfilled, (state, action) => {
        state.bmiChartLoading = false;
        state.bmiChartError = null;
        state.bmiChart = action.payload;
      })
      .addCase(fetchBMIChartData.rejected, (state, action) => {
        state.bmiChartLoading = false;
        state.bmiChartError = action.error.message;
      })

      .addCase(fetchHealthTrackingData.pending, (state) => {
        state.healthTrackingLoading = true;
        state.healthTrackingError = null;
        state.healthTracking = null;
      })
      .addCase(fetchHealthTrackingData.fulfilled, (state, action) => {
        state.healthTrackingLoading = false;
        state.healthTrackingError = null;
        state.healthTracking = action.payload;
      })
      .addCase(fetchHealthTrackingData.rejected, (state, action) => {
        state.healthTrackingLoading = false;
        state.healthTrackingError = action.error.message;
      })

      .addCase(fetchWTF360ConsultationsData.pending, (state) => {
        state.wtf360ConsultationsLoading = true;
        state.wtf360ConsultationsError = null;
        state.wtf360Consultations = null;
      })
      .addCase(fetchWTF360ConsultationsData.fulfilled, (state, action) => {
        state.wtf360ConsultationsLoading = false;
        state.wtf360ConsultationsError = null;
        state.wtf360Consultations = action.payload;
      })
      .addCase(fetchWTF360ConsultationsData.rejected, (state, action) => {
        state.wtf360ConsultationsLoading = false;
        state.wtf360ConsultationsError = action.error.message;
      })

      .addCase(fetchSegmentMembersData.pending, (state) => {
        state.segmentMembersLoading = true;
        state.segmentMembersError = null;
      })
      .addCase(fetchSegmentMembersData.fulfilled, (state, action) => {
        state.segmentMembersLoading = false;
        state.segmentMembersError = null;
        state.segmentMembers = action.payload;
      })
      .addCase(fetchSegmentMembersData.rejected, (state, action) => {
        state.segmentMembersLoading = false;
        state.segmentMembersError = action.error.message;
      })

      .addCase(fetchDiscountApprovalAccessData.pending, (state) => {
        state.discountApprovalAccessLoading = true;
        state.discountApprovalAccessError = null;
      })
      .addCase(fetchDiscountApprovalAccessData.fulfilled, (state, action) => {
        state.discountApprovalAccessLoading = false;
        state.discountApprovalAccessError = null;
        state.discountApprovalAccess = action.payload;
      })
      .addCase(fetchDiscountApprovalAccessData.rejected, (state, action) => {
        state.discountApprovalAccessLoading = false;
        state.discountApprovalAccessError = action.error.message;
      })

      .addCase(fetchCallLogsData.pending, (state) => {
        state.callLogsLoading = true;
        state.callLogsError = null;
      })
      .addCase(fetchCallLogsData.fulfilled, (state, action) => {
        state.callLogsLoading = false;
        state.callLogsError = null;
        state.callLogsData = action.payload;
      })
      .addCase(fetchCallLogsData.rejected, (state, action) => {
        state.callLogsLoading = false;
        state.callLogsError = action.error.message;
      })

      .addCase(fetchTrainerStatsData.pending, (state) => {
        state.trainerStatsLoading = true;
        state.trainerStatsError = null;
      })
      .addCase(fetchTrainerStatsData.fulfilled, (state, action) => {
        state.trainerStatsLoading = false;
        state.trainerStatsError = null;
        state.trainerStatsData = action.payload;
      })
      .addCase(fetchTrainerStatsData.rejected, (state, action) => {
        state.trainerStatsLoading = false;
        state.trainerStatsError = action.error.message;
      })

      .addCase(fetchTrainerStatsDetailsData.pending, (state) => {
        state.trainerStatsDetailsLoading = true;
        state.trainerStatsDetailsError = null;
      })
      .addCase(fetchTrainerStatsDetailsData.fulfilled, (state, action) => {
        state.trainerStatsDetailsLoading = false;
        state.trainerStatsDetailsError = null;
        state.trainerStatsDetailsData = action.payload;
      })
      .addCase(fetchTrainerStatsDetailsData.rejected, (state, action) => {
        state.trainerStatsDetailsLoading = false;
        state.trainerStatsDetailsError = action.error.message;
      })

      .addCase(fetchWTF360InquiryData.pending, (state) => {
        state.wtf360InquiryLoading = true;
        state.wtf360InquiryError = null;
      })
      .addCase(fetchWTF360InquiryData.fulfilled, (state, action) => {
        state.wtf360InquiryLoading = false;
        state.wtf360InquiryError = null;
        state.wtf360Inquiry = action.payload;
      })
      .addCase(fetchWTF360InquiryData.rejected, (state, action) => {
        state.wtf360InquiryLoading = false;
        state.wtf360InquiryError = action.error.message;
      })

      .addCase(fetchPreSaleGymLeadsData.pending, (state) => {
        state.preSaleGymLeadsLoading = true;
        state.preSaleGymLeadsError = null;
      })
      .addCase(fetchPreSaleGymLeadsData.fulfilled, (state, action) => {
        state.preSaleGymLeadsLoading = false;
        state.preSaleGymLeadsError = null;
        state.preSaleGymLeads = action.payload;
      })
      .addCase(fetchPreSaleGymLeadsData.rejected, (state, action) => {
        state.preSaleGymLeadsLoading = false;
        state.preSaleGymLeadsError = action.error.message;
      });
  },
});

export default prospectSlice.reducer;
